<template>
  <transition
    name="fade" 
    mode="out-in"
  >
    <div class="main">
      <div class="main__inner">
        <div
          v-if="mainLoading"
          class="main__loader"
        >
          <ap-loader />
        </div>
        <div
          v-else
          class="main__content"
        >
          <div class="main__banner">
            <main-banner
              v-if="isDefault"
              class="main__default container"
            />
            <tele2-banner               
              v-if="isTele2"
              class="main__tele2"
            />
              
            <altel-banner
              v-if="isAltel"
              class="main__altel" 
            />
            <operator
              v-if="isDefault"
              class="container"
            />
          </div>
          <div class="main__form container">
            <div class="main__title">{{$t('transfer')}}</div>
            <transfer />
          </div>
          <div
            v-if="isAltel || isTele2"
            class="main__catalogs"
          >
            <service-category from-main />
          </div>
          
          <div
            v-if="isDefault" 
            class="main__cards container"
          >
            <discount-banner class="card"/>
            <wallet-banner class="card"/>
          </div>
          <div
            v-if="isDefault"
            class="main__catalogs container" 
          >
            <service-card-container
              :services="serviceList"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { ALTEL, TELE2 } from '@/constant';
  
import ApLoader from '@/components/UI/apLoader.vue';

import AltelBanner from '@/components/Banners/AltelBanner.vue';
import DiscountBanner from '@/components/Banners/DiscountBanner.vue';
import MainBanner from '@/components/Banners/MainBanner.vue';
import ServiceCardContainer from './Services/ServiceCardContainer.vue';
import SnackBar from '@/components/SnackBar.vue';
import Tele2Banner from '@/components/Banners/Tele2Banner.vue';
import Transfer from '@/components/Transfers.vue';
import WalletBanner from '@/components/Banners/WalletBanner.vue';
import Operator from '@/components/Operator.vue';
import ServiceCategory from './Services/ServiceCategoryView.vue';

export default defineComponent({
  components: {
    ServiceCardContainer,
    ApLoader,
    DiscountBanner,
    WalletBanner,
    MainBanner,
    SnackBar,
    Tele2Banner,
    AltelBanner,
    Transfer,
    Operator,
    ServiceCategory
  },
  setup() {
    const store = useStore();
    const { t } = useI18n();

    const mainLoading = ref(false);
    const isDefault = computed(() => store.getters['isDefault']);

    const merchant = computed(() => store.getters['merchant']);
    const language = computed(() => store.getters['language']);


    const isAltel = computed(() => merchant.value === ALTEL);
    const isTele2 = computed(() => merchant.value === TELE2);



    const serviceList = computed(() =>  {
      const { favorites } = store.getters['services/services'];
      if (favorites) {
        let propertyValues = Object.values(favorites);
        const temp = propertyValues.map(item => JSON.parse(JSON.stringify(item)));
        temp.push({
          name: 'Все услуги',
          icon: require('@/assets/img/category.png'),
          id: 9999,
          url: '/service-category' 
        });
        return temp;
      }
      return [];
    });

    const getServices =  async() => {
      try {

        mainLoading.value = true;

        await store.dispatch('services/getServices', {
          language: language.value
        });
      } catch (err){
        if (err instanceof Error) {
          console.log(err.message);
        } else {
          console.log('Unexpected error', err);
        }
      } finally {
        mainLoading.value = false;
      }
    };


    onMounted(() => {
      getServices();
    });

    return {
      serviceList,
      isDefault,
      isAltel,
      isTele2,
      mainLoading,
      t
    };
  },
});
</script>
<style scoped lang="scss">
.main{
  &__title{
    font-weight: 700;
    font-size: 28px;
    margin-bottom: 24px;
    line-height: 34px;
  }
  &__catalogs {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
.default{
  .main{
    &__banner{
      margin-bottom: 30px;
    }
    &__default{
      display: block;
    }
    &__tele2{
      display: none;
    }
    &__altel{
      display: none;
    }
    &__form{
      margin-bottom: 24px;
    }
    &__cards{
      display: flex;
      margin-bottom: 104px;
      gap: 24px;
      .card{
        flex: 1;
      }
    }
  }
}
.tele2, .altel{
  .main{
    &__form{
      margin-bottom: 93px;
    }
    &__banner{
      margin-bottom: 0;
    }
    &__default{
      display: none;
    }
    &__cards{
      display: none;
    }
  }
}
.altel{
  .main{
    &__tele2{
      display: none;
    }
    &__altel{
      display: block;
    }
    &__title{
      color: $altel-primary-black;
    }

  }
}
.tele2{
  .main{
    &__tele2{
      display: block;
    }
    &__altel{
      display: none;
    }
    &__title{
      color: $tele2-primary-black;
    }
  }
}

@media (min-width:320px) and (max-width: 641px)  { 
  .default{
  .main{
    &__cards{
      display: flex;
      flex-direction: column;
      gap: 24px;
      .card{
        flex: 1;
      }
    }

  }
  }
  .tele2, .altel{
    .main{
      &__form{
        margin-bottom: 40px;
      }
    }
  }
}
@media (min-width:320px) and (max-width: 1024px)  { 
  .tele2, .altel{
    .main{
      &__form{
        margin-bottom: 40px;
      }
      &__banner{
        margin-bottom: 40px;
      }
    }
  }
}
</style>
